import React from 'react';

import styled from 'styled-components';

import { useFlag } from 'state/launchdarkly';
import { useStoreContext } from 'state/store';
import { useUIContext } from 'state/ui';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

const ViewContainer = styled.div`
  background: ${Styles.color.background};
  display: flex;
  flex-direction: column;
  flex-grow: 2;
  padding-top: ${p => p.$topInset}px;
  height: calc(100vh - ${p => p.$bottomInset + p.$topInset}px);
  ${Styles.mobileFullscreen`
    padding-top: calc(${p => p.$topInset}px - env(safe-area-inset-top));
  `}
`;

const LayoutViewContainer = props => {
  const { isStoreOpenAndAvailable } = useStoreContext();
  const { appFooterDimensions, bottomServiceDimensions, appHeaderDimensions } = useUIContext();
  const enableBottomServiceMode = useFlag(LaunchDarklyFlag.ENABLE_BOTTOM_SERVICE_MODE);
  const bottomHeight = enableBottomServiceMode
    ? bottomServiceDimensions.height + appFooterDimensions.height
    : 0;
  return (
    <ViewContainer
      {...props}
      padForServiceMode={isStoreOpenAndAvailable}
      $topInset={appHeaderDimensions.height}
      $bottomInset={bottomHeight}
    />
  );
};

export default LayoutViewContainer;
